import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider 
      theme={{
        primaryColor: 'blue',
        fontFamily: 'Pangolin, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        headings: { fontFamily: 'Pangolin, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif' },
        colors: {
        },
      }}
      defaultColorScheme="light"
    >
      <App />
    </MantineProvider>
  </React.StrictMode>
);